import api from '@/services/api'
import { ls } from '@/services/storage'
import { authorizeApi } from '@/services/http'

const LS_TTL_SECONDS_AUTH_GLOBAL = 60 * 60 * 24 * 7 // 7 days
const LS_TTL_SECONDS_AUTH_PHONE = 60 * 60 // 1 hour

const saved = ls.get('auth-v2') || {}
if (saved.token) {
  authorizeApi(saved.token)
}

export default {
  namespaced: true,
  state: {
    token: saved.token,
    phoneNumber: saved.phoneNumber,
    isGlobalPlayer: saved.isGlobalPlayer
  },
  getters: {
    isLoggedIn: state => !!state.token
  },
  mutations: {
    setAuth (state, { token, phoneNumber, isGlobalPlayer }) {
      state.token = token
      state.phoneNumber = phoneNumber
      state.isGlobalPlayer = isGlobalPlayer
      const ttl = isGlobalPlayer ? LS_TTL_SECONDS_AUTH_GLOBAL : LS_TTL_SECONDS_AUTH_PHONE
      ls.set('auth-v2', { token, phoneNumber, isGlobalPlayer }, ttl)
      authorizeApi(token)
    },
    logout (state) {
      state.token = null
      state.phoneNumber = null
      state.isGlobalPlayer = null
      ls.del('auth-v2')
      authorizeApi(null)
    }
  },
  actions: {
    async login ({ commit, dispatch }, payload) {
      const data = await api.auth.login(payload)
      commit('setAuth', { ...data, phoneNumber: payload.phoneNumber })
      await dispatch('players/loadAccount', { ignoreCache: true }, { root: true })
    },
    logout ({ commit }) {
      commit('logout')
      commit('players/deletePlayer', null, { root: true })
    }
  }
}
